export const EXPERIMENT_CUSTOMISATION = 'pdp-customisation-ab';
